import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Regions } from '../../hooks/useConfiguration';
import { assertNever } from '../../utils/assertNever';

export const ContactForm: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();
  switch (region) {
    case 'us':
      return (
        <>
          <h3>{t('privacy.contactForm.title')}</h3>
          <p>
            <Trans t={tRegion} i18nKey='privacy.contactForm.text'>
              If you contact us via email or the contact form
              <a className='contacts-block__link' href={`mailto:${tRegion('contactData.mailTo')}`}>
                info@lm-americas.com
              </a>
              , the information you provide will be stored for the purposes of processing your inquiry and for potential
              follow-up questions.
            </Trans>
          </p>
        </>
      );

    case 'eu':
      return (
        <>
          <h3>{t('privacy.contactForm.title')}</h3>
          <p>{tRegion('privacy.contactForm.text')}</p>
        </>
      );

    default:
      assertNever(region);
  }
};
